import { createRouter, createWebHistory } from 'vue-router'
import User from '../views/User.vue'
import NFT from '../views/NFT.vue'
import Market from '../views/Market.vue'
import Home from '../views/Home.vue'

const routes = [

  {
    path: '/tmpr/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Registrare la Marca su NFT',
      metaTags: [
        {
          name: 'description',
          content: 'Registra tu marca en línea, tokeniza tu marca, crea tu NFT con nuestro contrato inteligente, rápido y barato, con Binance Smart Chain y Metamask'
        },
        {
          property: 'og:description',
          content: 'Registra tu marca en línea, tokeniza tu marca, crea tu NFT con nuestro contrato inteligente, rápido y barato, con Binance Smart Chain y Metamask'
        },
        {
          name: 'keywords',
          content: 'nft, nft crypto, nft sito, nft wallet, nft marketplace Binance, marca registrada, símbolo de marca registrada,  nft marketplace, nft art, plataforma nft, registro de marca, gas fees, nft fees, crea nft, como crear nft, registración de marca, registrar marca, Smart Contract, smart contract blockchain, smart contract Binance, token ERC721'
        }
      ]
    }
  },

  {
    path: '/tmpr/user',
    name: 'User',
    component: User,
    meta: {
      title: 'Registrare la Marca su NFT'
    }
  },
  {
    path: '/tmpr/market',
    name: 'Market',
    component: Market,
    meta: {
      title: 'Mercato dei Marchi su NFT'
    }
  },
  {
    path: '/tmpr/nft/:account/:id',
    name: 'NFT',
    component: NFT,
    meta: {
      title: 'Detagli della Marca'
    },
    props: true
  },
  {
    path: '/tmpr/come-installare-metamask',
    name: 'MetamaskGuide',
    component: () => import('../views/MetamaskGuide.vue'),
    meta: {
      title: 'Come Installare Metamask'
    },
    props: true
  },
  {
    path: '/tmpr/classificazione-marchi',
    name: 'Nizza',
    component: () => import('../views/Nizza.vue'),
    meta: {
      title: 'Classificazione Marchi di Nizza'
    }
  },
  {
    path: '/tmpr/clasificacion-niza',
    name: 'Niza',
    component: () => import('../views/Niza.vue'),
    meta: {
      title: 'Clasificación De Niza - 11 edición, versión 2021'
    }
  },
  {
    path: '/tmpr/collegare-metamask',
    name: 'CollegareMetaMask',
    component: () => import('../views/CollegareMetaMask.vue'),
    meta: {
      title: 'Collegare MetaMask alla smart chain di Binance'
    }
  },
  {
    path: '/tmpr/como-conectar-metamask',
    name: 'ComoConectarMetaMask',
    component: () => import('../views/ComoConectarMetaMask.vue'),
    meta: {
      title: 'Collegare MetaMask alla smart chain di Binance'
    }
  },
  {
    path: '/tmpr/metamask-connected',
    name: 'MetaMaskConnected',
    component: () => import('../views/MetaMaskConnected.vue'),
    meta: {
      title: 'Collegare MetaMask alla smart chain di Binance'
    }
  },
  {
    path: '/tmpr/come-caricare-logo-nft',
    name: 'Pictures',
    component: () => import('../views/Pictures.vue'),
    meta: {
      title: 'Guida al caricamento dei loghi'
    }
  },
  {
    path: '/tmpr/questions',
    name: 'Questions',
    component: () => import('../views/Questions.vue'),
    meta: {
      title: 'FAQ'
    }
  },
  {
    path: '/tmpr/tmpr-vip-service',
    name: 'TmprVipService',
    component: () => import('../views/TmprVipService.vue'),
    meta: {
      title: 'TMPR register & NFT, VIP service'
    }
  },
  {
    path: '/tmpr/termini-e-condizioni',
    name: 'Terms',
    component: () => import('../views/Terms.vue'),
    meta: {
      title: 'Terms and Conditions TMPR',
      metaTags: [
        {
          name: 'description',
          content: 'TMPR, TradeMark Public Register is a service provided by OPM CORPORATION I and the portal CryptoCurrency10.com'
        },
        {
          property: 'og:description',
          content: 'TMPR, TradeMark Public Register is a service provided by OPM CORPORATION I and the portal CryptoCurrency10.com'
        },
        {
          name: 'keywords',
          content: 'cryptocurrency news, cryptocurrency quotes, cryptocurrency trend, trademark, registered trademark, registered trademark symbol, Trademark Registry, nft, nft marketplace, nft art, nft platform, Cryptocurrency Registry, cryptocurrency trading, emerging cryptocurrencies, cryptocurrency investing, Bitcoin value, Bitcoin dollar, Bitcoin news'
        }
      ]
    }
  }

]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
  // `/nested`'s will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if(previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
      // Add the meta tags to the document head.
      .forEach(tag => document.head.appendChild(tag));

  next();
});

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})

export default router
